import { Grid, Switch } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { RoutalText } from './RoutalText';
interface RoutalSwitchStylesProps {
  switchBaseStyles?: React.CSSProperties;
  thumbStyles?: React.CSSProperties;
  trackStyles?: React.CSSProperties;
}
interface RoutalSwitchProps {
  checked?: boolean;
  onChange?: (...args: any[]) => any;
  key?: string;
  label?: string | React.ReactElement;
  size?: `small` | `medium`;
  switchStyles?: RoutalSwitchStylesProps;
}

// Add additional styles if needed
const MaterialUISwitch = styled(Switch)(({ switchBaseStyles, thumbStyles, trackStyles }: RoutalSwitchStylesProps) => ({
  '& .MuiSwitch-switchBase': {
    ...switchBaseStyles,
    '&.Mui-checked': {},
  },
  '& .MuiSwitch-thumb': {
    ...thumbStyles,
  },
  '& .MuiSwitch-track': {
    ...trackStyles,
  },
}));

export const RoutalSwitch = ({ label, checked, onChange, key, size, switchStyles }: RoutalSwitchProps) => {
  return (
    <Grid container direction="row" alignItems="center" style={{ width: `auto` }}>
      {label && <RoutalText>{label}</RoutalText>}
      <MaterialUISwitch
        switchBaseStyles={switchStyles?.switchBaseStyles}
        thumbStyles={switchStyles?.thumbStyles}
        trackStyles={switchStyles?.trackStyles}
        key={key}
        checked={checked}
        onChange={onChange}
        value={checked}
        size={size}
        color="primary"
      />
    </Grid>
  );
};
